import styles from '@/styles/footer.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import getConfig from 'next/config'
import { Button, Input } from 'antd';
const { publicRuntimeConfig } = getConfig();
const apiDomain = publicRuntimeConfig.apiDomain;
const imageDomain = publicRuntimeConfig.imageDomain
import FollowiconFb from '@/svgs/share-icon/Followicon-fb.svg'
import FollowiconTw from '@/svgs/share-icon/Followicon-tw.svg'
import FollowiconPin from '@/svgs/share-icon/Followicon-pin.svg'
import FollowiconBr from '@/svgs/share-icon/Followicon-br.svg'
import FollowiconTiktop from '@/svgs/share-icon/Followicon-tt.svg'
import FollowiconIns from '@/svgs/share-icon/Followicon-ins.svg'
import FollowiconThreads from '@/svgs/share-icon/Followicon-threads.svg'
import VisaIcon from '@/svgs/pay-icon/VISA.svg'
import MastercardIcon from '@/svgs/pay-icon/Mastercard.svg'
import PaypalIcon from '@/svgs/pay-icon/Paypal.svg'
import AfterpayIcon from '@/svgs/pay-icon/afterpay-logo.svg'
import ZipIcon from '@/svgs/pay-icon/Zip.svg'
import LaybuyIcon from '@/svgs/pay-icon/laybuy-.svg'
import { useEffect, useState } from 'react';
import systemApi from '@/service/modules/systemApi';

export default function Footer() {
  const currentYear = new Date().getFullYear(); // 获取当前年份
  function handlePageJump(url: string, e: any) {
    // 阻止a标签默认行为
    e.preventDefault()

    window.location.href = `${url}`
  }

  const helpData = [
    {
      title: 'Company Info',
      helpList: [
        { title: 'About Us', link: `${apiDomain}/article/AboutUs` },
        { title: 'Terms & Conditions', link: '/article/terms' },
        { title: 'Privacy Statement', link: '/article/privacy' },
        { title: 'Warranty Policy', link: '/article/warranty' },
        { title: 'Site Map', link: '/sitemap' }
      ]
    }, {
      title: 'Customer Service',
      helpList: [
        { title: 'Contact Us', link: '/contact-us' },
        { title: 'My Account', link: '/myaccount' },
        { title: 'Frequently Asked Questions(FAQ)', link: '/article/faq' },
        { title: 'Afterpay', link: '/afterpay' },
        { title: 'Zippay', link: 'https://zip.co/nz/how-it-works/' }
      ]
    }, {
      title: 'Shipping & Returns',
      helpList: [
        { title: 'Shipping Guide', link: '/article/shipping' },
        { title: 'Return & Refund Policy', link: '/article/return' },
        { title: 'Track Your Order', link: '/myaccount/order/0' }
      ]
    }
  ]
  const helpItems = helpData.map(item =>
    <div key={item.title} className={styles['help-item']}>
      <div className={styles['help-title']}>{item.title}</div>
      <ul className={styles['child-list']}>
        {
          item.helpList.map(help => (
            <li key={help.link}>
              <Link
                key={help.title}
                href={help.link}
                passHref
                legacyBehavior
              >
                <a
                  onClick={(e: any) => handlePageJump(`${help.link}`, e)}
                  rel="noopener noreferrer"
                >{help.title}</a>
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  )

  const followList = [
    {
      compoent: FollowiconFb,
      url: 'https://www.facebook.com/bestdeals.co.nz'
    },
    {
      compoent: FollowiconTw,
      url: 'https://twitter.com/BestDealsCoNz'
    },
    {


      compoent: FollowiconPin,
      url: 'https://www.pinterest.com/bestdealsconz/'
    },
    {
      compoent: FollowiconBr,
      url: 'http://blog.bestdeals.co.nz/'
    },
    {
      compoent: FollowiconTiktop,
      url: 'https://www.tiktok.com/@bestdealsnz'
    },
    {
      compoent: FollowiconIns,
      url: 'https://www.instagram.com/bestdealsnz/'
    },
    {
      compoent: FollowiconThreads,
      url: 'https://www.threads.net/@bestdealsnz'
    }
  ]

  const payIcon = [
    VisaIcon,
    MastercardIcon,
    PaypalIcon,
    AfterpayIcon,
    ZipIcon
  ]

  const [middleSubscribeValue, setMiddleSubscribeValue] = useState("")
  const [subscribeBanner, setSubscribeBanner] = useState("")

  useEffect(() => {
    getBanner()
  }, [])

  const getBanner = async () => {
    try {
      // const res = await systemApi.getFullBanners({ home: "homepageBottomBanner" })
      const res = await systemApi.getFullBanners()
      const { homepageBottomBanner } = res.data.home
      setSubscribeBanner(homepageBottomBanner ? homepageBottomBanner.imgUrl : `${imageDomain}/subscribe/subscribe-footer.png`)
    } catch (error: any) {
      console.log(error.message);

    }
  }

  const handleMiddleSubscribeChange = (event: any) => {
    setMiddleSubscribeValue(event.target.value)
  }

  const handleSendSubscribe = () => {
    window.location.href = `https://${window.location.host}/newsletters?email=${middleSubscribeValue}`
  }

  return (
    <>
      <div className={styles['footer-box']} id="footerBox">
        <div className={styles['help-box']}>
          <div className={styles['subscribe-box']}>
            {
              subscribeBanner
              &&
              <Link legacyBehavior href={'/newsletters'}>
                <a rel="noopener noreferrer">
                  <Image src={subscribeBanner} alt="subscribe" width={631} height={122} layout="intrinsic" />
                </a>
              </Link>
            }
            <div className={styles['subscribeForm']}>
              <Input value={middleSubscribeValue} onChange={handleMiddleSubscribeChange} className={styles['subscribeForm-input']} placeholder='Email Address' />
              <Button className={styles['subscribeForm-btn']} onClick={handleSendSubscribe}>Subscribe</Button>
            </div>
          </div>
          <div className={styles['content']}>
            {helpItems}

            <div className={styles['help-item']}>
              <div className={styles['help-title']}>Follow Us</div>
              <div className={styles['follow-list']}>
                {
                  followList.map(item =>
                    <div className={styles['followItem']} key={item.url}>
                      <Link href={item.url} passHref legacyBehavior><a rel="noopener noreferrer" target="_blank"><item.compoent /></a></Link>
                    </div>)
                }
              </div>
              <div className={styles['help-title']}>Secured By</div>
              <Image src={`${imageDomain}/verified&secured.png`} width={132} height={32} layout="intrinsic" alt='verified&secured' />
            </div>

            <div className={styles['help-item']}>
              <div className={styles['help-title']}>We Acceept</div>
              <div className={styles['acceept-list']}>
                {
                  payIcon.map(Icon =>
                    <div className={styles['acceeptItem']} key={Icon.name}>
                      <Icon />
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['copyright']}>© Copyright 2012 - {currentYear} Best Deals Store. All Rights Reserved.</div>
    </>
  )
}
